import { useQuery } from 'react-query';

import { deep_research_prompts_api_article_path } from '@routes';
import request from '@utils/backend-api/request';

export const ARTICLE_DEEP_RESEARCH_PROMPTS_KEY = 'ARTICLE_DEEP_RESEARCH_PROMPTS';

export function useArticleDeepResearchPrompts(articleId: number) {
  const { data, isLoading } = useQuery(
    [ARTICLE_DEEP_RESEARCH_PROMPTS_KEY, articleId],
    async () => {
      return await request('get', deep_research_prompts_api_article_path({ id: articleId }));
    },
    {
      retry: (failureCount, error) =>
        (error as { error?: string })?.error !== 'Not authorized' && failureCount < 3,
    }
  );

  return {
    prompts: (data?.prompts as string[]) || [],
    isLoading,
  };
}
